<template>

    <v-container>
        <v-breadcrumbs divider=">"></v-breadcrumbs>
        <v-row class="text-center">

            <v-col class="mb-5" cols="12">

                <h2 class="headline font-weight-bold mb-3">
                    お問い合わせ
                </h2>

                <InquiryForm/>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
import InquiryForm from './InquiryForm.vue';
export default {
    name: "Inquiry",
    data: () => ({
        isActive: false,
    }),
    components: { InquiryForm }
}
</script>
  